import React from 'react';
import { BarChart3 } from 'lucide-react';
import { Card, CardContent } from 'components/ui/card';
import { useTranslation } from 'react-i18next';

export const StatisticsPage: React.FC = () => {
    const { t } = useTranslation();
    return (<div className="space-y-8 max-w-4xl">
      <h2 className="text-2xl font-bold text-foreground">{t("statistics")}</h2>

      <Card className="border-2 border-dashed border-border">
        <CardContent className="p-10 flex flex-col items-center text-center gap-4">
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-muted text-muted-foreground">
            <BarChart3 className="h-[18px] w-[18px]" aria-hidden/>
          </span>
          <div className="space-y-2 max-w-md">
            <p className="text-lg font-semibold text-foreground">{t("coming_soon")}</p>
            <p className="text-sm text-muted-foreground">{t("statistics_coming_soon_desc")}</p>
          </div>
        </CardContent>
      </Card>
    </div>);
};
export default StatisticsPage;
